module.exports = __webpack_public_path__ + "static/ss-9dace40e00a2eefa8616c282e77e6b41.jpg";